export default __webpack_public_path__ + "static/ayvakit-logo-tablets-9e66ae544c300bce968ccad109200d4c.png";